import { Plugin, Store } from "vuex";
import { UPDATE_STATUS } from "@/store/api";
import { ApiStatus, ApiStoreStateInterface } from "./api.types";
import { api } from "../services/api";

const ApiStorePlugin: Plugin<any> = (store: Store<{ api: ApiStoreStateInterface }>) => {
  // API status
  api.status().subscribe({
    next: (status) => {
      store.commit('api/' + UPDATE_STATUS, status as ApiStatus)
    }
  })
}

export default ApiStorePlugin